import {
  AUTOMATIC_REPORTS_ENABLED,
  FEATURE_AGENCIES_REPORT,
} from "@/constants";
import Settings from "@/views/Settings/index.vue";
import AutomaticReports from "@/views/Settings/AutomaticReports.vue";
import ReportTemplates from "@/views/Settings/ReportTemplates.vue";
import SettingsPlaceholder from "@/views/Settings/SettingsPlaceholder.vue";

const meta = {
  allowAgencies: true,
  feature: FEATURE_AGENCIES_REPORT,
};

const settingsRoutes = [
  {
    path: "/settings",
    component: Settings,
    name: "Settings",
    redirect: { name: "SettingsAutomaticReports" },
    children: [
      {
        path: "automatic-reports",
        component: AutomaticReports,
        name: "SettingsAutomaticReports",
        meta,
      },
      {
        path: "report-templates",
        component: ReportTemplates,
        name: "SettingsTemplateReport",
        meta,
      },
      {
        path: "time-slots",
        component: SettingsPlaceholder,
        name: "SettingsTimeSlots",
        meta,
      },
      {
        path: "segments",
        component: SettingsPlaceholder,
        name: "SettingsSegments",
        meta,
      },
      {
        path: "prices",
        component: SettingsPlaceholder,
        name: "SettingsPrices",
        meta,
      },
    ],
  },
];

// AutomaticReport hidden: swallow /settings and every child (the trailing `*`
// matches the descendants too) so bookmarked URLs land on the Dashboard rather
// than an unmatched blank route - this app has no 404 view.
const hiddenSettingsRoutes = [
  { path: "/settings*", redirect: { name: "Dashboard" } },
];

export default AUTOMATIC_REPORTS_ENABLED
  ? settingsRoutes
  : hiddenSettingsRoutes;
